<div style="display: flex; height: 100%;">
  <div style="display: flex; flex-direction: column; overflow: auto; flex-shrink: 1; flex-grow: 1;" [style.flex.px]="menuResizer.menuWidth" *ngIf="userConfigService.inRoles(Role.StandardFeatureSet, Role.Administrator) && showLeftPane">
    <mat-accordion multi>

      <!-- Search Quick Links -->
      <lex-expandable-container panelTitle="Search Quick Links" [controlModuleId]="controlModuleIds.SearchQuickLinks"
                                *inRole="[Role.StandardFeatureSet, Role.Administrator]">
        <div lex-nav-list>
          <div class="grey-header">
            <div class="grey-header-left">Shared</div>
            <mat-icon class="grey-header-right">share</mat-icon>
          </div>
          @for(search of searchQuickLinks.shared; track search) {
          <span lex-list-item [matTooltip]="search.title" matTooltipPosition="right"><a [routerLink]="[]" (click)="setSearch(search)">{{search.title}}</a></span>
          }
        </div>
        <div lex-nav-list>
          <div class="grey-header-below">
            <div class="grey-header-left">Pinned</div>
            <mat-icon class="grey-header-right">push_pin</mat-icon>
          </div>
          @for(search of searchQuickLinks.pinned; track search) {
          <span lex-list-item [matTooltip]="search.title" matTooltipPosition="right"><a [routerLink]="[]" (click)="setSearch(search)">{{search.title}}</a></span>
          }
        </div>
        <div lex-nav-list>
          <div class="grey-header-below">
            <div class="grey-header-left">Recent</div>
            <mat-icon class="grey-header-right">history</mat-icon>
          </div>
          @for(search of searchQuickLinks.recent; track search) {
          <span lex-list-item [matTooltip]="search.title" matTooltipPosition="right"><a [routerLink]="[]" (click)="setSearch(search)">{{search.title}}</a></span>
          }
        </div>

        <button mat-button color="primary" (click)="this.showQuickLinkManagement('Search', 'Searches', this.searchQuickLinks, this.savedSearchesService)">EDIT</button>
      </lex-expandable-container>

      <!-- Groups -->
      <lex-expandable-container panelTitle="Groups" [controlModuleId]="controlModuleIds.Groups">
        <a routerLink="/near-dup-text-groupings">Near Dup Groups</a><br>
        <a routerLink="/EmailThreadGroupings">Email Thread Groups</a>
      </lex-expandable-container>

      <!-- Folders-->
      <lex-expandable-container panelTitle="Folders" [controlModuleId]="controlModuleIds.Folders">
        <lex-folders></lex-folders>
      </lex-expandable-container>

      <!-- Sort -->
      <lex-expandable-container panelTitle="Sort" [controlModuleId]="controlModuleIds.Sort" *ngIf="!hasActiveSearch">
        <button mat-button color="primary" (click)="selectSort()">SELECT SORT</button>
      </lex-expandable-container>

      <!-- Filters -->
      <lex-expandable-container panelTitle="Filter" [controlModuleId]="controlModuleIds.Filters">
        <button mat-button color="primary" (click)="selectFiltersNew()">SELECT FILTER</button>
        <!--<button mat-button color="primary" (click)="selectFiltersOld()">SELECT FILTER OLD</button>-->
      </lex-expandable-container>

      <!-- Filter Quick Links -->
      <lex-expandable-container panelTitle="Filter Quick Links" [controlModuleId]="controlModuleIds.FilterQuickLinks">
        <div lex-nav-list>
          <div class="grey-header">
            <div class="grey-header-left">Shared</div>
            <mat-icon class="grey-header-right">share</mat-icon>
          </div>
          @for(filter of filterQuickLinks.shared; track filter) {
          <span lex-list-item [matTooltip]="filter.title" matTooltipPosition="right">
            <a [routerLink]="[]" (click)="setAndLoadFilter(filter)">{{filter.title}}</a>
          </span>
          }
        </div>
        <div lex-nav-list>
          <div class="grey-header-below">
            <div class="grey-header-left">Pinned</div>
            <mat-icon class="grey-header-right">push_pin</mat-icon>
          </div>
          @for(filter of filterQuickLinks.pinned; track filter) {
          <span lex-list-item [matTooltip]="filter.title" matTooltipPosition="right">
            <a [routerLink]="[]" (click)="setAndLoadFilter(filter)">{{filter.title}}</a>
          </span>
          }
        </div>
        <div lex-nav-list>
          <div class="grey-header-below">
            <div class="grey-header-left">Recent</div>
            <mat-icon class="grey-header-right">history</mat-icon>
          </div>
          @for(filter of filterQuickLinks.recent; track filter) {
          <span lex-list-item [matTooltip]="filter.title" matTooltipPosition="right">
            <a [routerLink]="[]" (click)="setAndLoadFilter(filter)">{{filter.title}}</a>
          </span>
          }
        </div>
        <button mat-button color="primary"
                (click)="this.showQuickLinkManagement('Filter', 'Filters', this.filterQuickLinks, this.filterService)">EDIT</button>
      </lex-expandable-container>

      <!-- Layouts -->
      <lex-expandable-container panelTitle="Layouts" [controlModuleId]="controlModuleIds.Fields">
        <button mat-button color="primary" (click)="showFields()">SELECT FIELDS</button>
        <button mat-button color="primary" (click)="manageDefaults()" *inRole="Role.AccountFeatureSet">MANAGE DEFAULTS</button>
      </lex-expandable-container>

      <!-- Layout Quick Links -->
      <lex-expandable-container panelTitle="Layout Quick Links" [controlModuleId]="controlModuleIds.FieldQuickLinks">
        <div lex-nav-list>
          <div class="grey-header">
            <div class="grey-header-left">Shared</div>
            <mat-icon class="grey-header-right">share</mat-icon>
          </div>
          @for(field of layoutQuickLinks.shared; track field) {
          <span lex-list-item [matTooltip]="field.title" matTooltipPosition="right"><a [routerLink]="[]" (click)="setLayout(field)">{{field.title}}</a></span>
          }
        </div>
        <div lex-nav-list>
          <div class="grey-header-below">
            <div class="grey-header-left">Pinned</div>
            <mat-icon class="grey-header-right">push_pin</mat-icon>
          </div>
          @for(field of layoutQuickLinks.pinned; track field) {
          <span lex-list-item [matTooltip]="field.title" matTooltipPosition="right"><a [routerLink]="[]" (click)="setLayout(field)">{{field.title}}</a></span>
          }
        </div>
        <div lex-nav-list>
          <div class="grey-header-below">
            <div class="grey-header-left">Recent</div>
            <mat-icon class="grey-header-right">history</mat-icon>
          </div>
          @for(field of layoutQuickLinks.recent; track field) {
          <span lex-list-item [matTooltip]="field.title" matTooltipPosition="right"><a [routerLink]="[]" (click)="setLayout(field)">{{field.title}}</a></span>
          }
        </div>
        <button mat-button color="primary" (click)="this.showQuickLinkManagement('Layout', 'Layouts', this.layoutQuickLinks, this.fieldLayoutViewModelService)">EDIT</button>
      </lex-expandable-container>

      <lex-expandable-container panelTitle="Multi Doc Edit" [controlModuleId]="controlModuleIds.MultiDocEdit" *ngIf="userConfigService.inRoles(Role.EditFeatureSet)">
        <lex-multi-doc-edit (reload)="load(paginator.pageIndex, false)" [searchParameter]="searchQuickLinks.searchParameter" [expandEmailFamilySelected]="expandEmailFamilySelected"></lex-multi-doc-edit>
      </lex-expandable-container>

      <!-- Export -->
      <lex-expandable-container *inRole="[Role.EditFeatureSet]" panelTitle="Export" [controlModuleId]="controlModuleIds.Export">
        <div *ngIf="!selectionService.selection.selected.length" class="ddlLabel">No Documents Selected</div>
        <button mat-button color="primary" [disabled]="!selectionService.selection.selected.length || exportingLog" (click)="exportLog()">EXPORT LOG TO EXCEL</button>
        <button mat-button color="primary" [disabled]="!selectionService.selection.selected.length" (click)="exportBriefcase()">EXPORT TO BRIEFCASE</button>
      </lex-expandable-container>

      <lex-expandable-container panelTitle="Export Operations" [controlModuleId]="controlModuleIds.ExportOperations" *inRole="Role.Operations" [disabled]="hasActiveSearch">
        <lex-export-operations (reload)="load()" [expandToEmailFamily]="expandEmailFamilySelected"></lex-export-operations>
      </lex-expandable-container>

      <!-- Processing -->
      <lex-expandable-container panelTitle="Processing" [controlModuleId]="controlModuleIds.Processing" *inRole="Role.Operations" [disabled]="hasActiveSearch">
        <lex-processing></lex-processing>
      </lex-expandable-container>

      <lex-expandable-container *inRole="[Role.EditFeatureSet]" panelTitle="Production Jobs" [controlModuleId]="controlModuleIds.Productions">
        <lex-production-job-select [searchParameter]="searchQuickLinks.searchParameter" [isProcessingOrIndexing]="isProcessingOrIndexing" [expandEmailFamilySelected]="expandEmailFamilySelected"></lex-production-job-select>
      </lex-expandable-container>
      <lex-expandable-container *inRole="[Role.Operations, Role.AccountFeatureSet]" panelTitle="Review Sets" [controlModuleId]="controlModuleIds.ReviewSet">
        <lex-review-set [searchParameter]="searchQuickLinks.searchParameter" [expandEmailFamilySelected]="expandEmailFamilySelected"></lex-review-set>
      </lex-expandable-container>
      <lex-expandable-container panelTitle="Archive Jobs" [controlModuleId]="controlModuleIds.ArchiveJobs" *inRole="Role.Operations">
        <lex-archive-job></lex-archive-job>
      </lex-expandable-container>
      <lex-expandable-container panelTitle="Delete Docs" [controlModuleId]="controlModuleIds.DeleteDocs" *inRole="Role.EditFeatureSet">
        <lex-delete-docs (reload)="refreshBrowse()" [searchParameter]="searchQuickLinks.searchParameter"></lex-delete-docs>
      </lex-expandable-container>

    </mat-accordion>
  </div>
  <div style="display: flex; overflow: hidden; width: 100%;">
    <div class="grip-handle" style="flex: 0 0 5px;" (mousedown)="menuResizer.onMenuResize($event)"></div>
    <div style="display: flex; flex-direction: column; padding: 20px; z-index: 1; overflow: hidden; width: 100%;">

      <!-- Filter Alert -->
      <div *ngIf="selectionService.selectedFilter" class="alert">
        <div>Filter Applied: {{selectionService.selectedFilter.filterText}}</div>
        <button mat-button (click)="clearFilter()" style="padding: 0 16px;">RESET</button>
      </div>

      <!-- Operation Alert -->
      <div *ngIf="selectionService.operationAlert" class="alert">
        <div>{{selectionService.operationAlert}}</div>
        <button mat-button (click)="selectionService.operationAlert = null">
          <mat-icon>clear</mat-icon>
        </button>
      </div>

      <!-- Search Operation Alert -->
      <div *ngIf="selectionService.searchOperationAlert && hasActiveSearch" class="alert">
        <div>{{selectionService.searchOperationAlert}}</div>
        <button mat-button (click)="selectionService.searchOperationAlert = null">
          <mat-icon>clear</mat-icon>
        </button>
      </div>

      <!-- Sort Alert -->
      <div *ngIf="sortAlert" class="alert">
        <div>Sort Applied: {{sortAlert[1]}}</div>
        <button mat-button (click)="sortAlertClear()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>

      <!-- Selection Alert -->
      <div *ngIf="selectionService.selectionAlert" class="alert">
        <div>{{selectionService.selectionAlert.Title.Prefix}}<b>{{selectionService.selectionAlert.Title.Count}}</b>{{selectionService.selectionAlert.Title.Suffix}}</div>
        <div>
          <button mat-button *ngIf="selectionService.selectionAlert.Button" (click)="selectionService.selectAll()" style="text-transform: uppercase;">
            {{selectionService.selectionAlert.Button.Prefix}}
            <b style="vertical-align: unset;">{{selectionService.selectionAlert.Button.Count}}</b>
            {{selectionService.selectionAlert.Button.Suffix}}
          </button>
          <button mat-button *ngIf="selectionService.selectionAlert.ShowClearButton" (click)="selectionService.deselectAll()">CLEAR</button>
        </div>
      </div>

      <!-- Timeout Alert -->
      <div *ngIf="timeoutAlert" class="alert">
        <div>Request overly broad. Too many documents or fields included. Please apply a filter to reduce the number of documents or reduce the number of fields showing. See help for details.</div>
        <button mat-button (click)="timeoutAlert = false">
          <mat-icon>clear</mat-icon>
        </button>
      </div>

      <!-- No Documents Alert -->
      <div *ngIf="noDocuments" class="alert">
        <div>User is not assigned to any documents.</div>
        <button mat-button (click)="noDocuments = false">
          <mat-icon>clear</mat-icon>
        </button>
      </div>

      <!-- Syntax Warning Alert -->
      <div *ngIf="syntaxWarning | async as warning" class="alert">
        <div *ngIf="warning.length > 0">{{warning}}</div>
        <button mat-button (click)="clearSyntaxWarning()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>

      <!-- Invalid Query Alert -->
      <div *ngIf="invalidQuery" class="alert">
        <div>Query is invalid or is not currently supported. See help for details.</div>
        <button mat-button (click)="invalidQuery = false">
          <mat-icon>clear</mat-icon>
        </button>
      </div>

      <!-- Truncated Result Info -->
      <div *ngIf="truncatedResult" class="alert" style="background-color: #c5cae9">
        <div>Search performed using the ranking method. See help for details.</div>
        <button mat-button (click)="truncatedResult = false">
          <mat-icon>clear</mat-icon>
        </button>
      </div>



      <mat-toolbar color="primary" class="toolbar-over-card" style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex; padding: 20px;">
        <!-- Title -->
        <div>Total: <span *ngIf="selectionService.dataSource.initialized">{{selectionService.dataSource.count | number}}</span></div>

        <div style="display: flex; font-size: medium; flex-grow: 1; justify-content: flex-end; align-items:center;">

          <div *ngIf="isEmailThreadFilter()" style="display: flex; align-items: center;">
            <button mat-button (click)="visualizeEmailThread()">VISUALIZE</button>

            <button mat-icon-button (click)="prevEmailThread()">
              <mat-icon>chevron_left</mat-icon>
            </button>
            <div style="align-self: center;">Email Thread</div>
            <button mat-icon-button (click)="nextEmailThread()">
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>

          <!-- Text Groups -->
          <div *ngIf="textGroupManager.active" style="display: flex;">
            <button mat-icon-button (click)="textGroupManager.movePrev()">
              <mat-icon>chevron_left</mat-icon>
            </button>
            <div style="align-self: center;">Viewing Group {{textGroupManager.currentGroupIndex + 1}} of {{textGroupManager.totalTextGroups}}</div>
            <button mat-icon-button (click)="textGroupManager.moveNext()">
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>

          <!-- Prev, Next, Expand -->
          <button mat-icon-button *ngIf="!isEmailThreadFilter()" [disabled]="!paginator.hasPreviousPage()" (click)="toolbarPrevPage()" matTooltip="Previous page">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <button mat-icon-button *ngIf="!isEmailThreadFilter()" [disabled]="!paginator.hasNextPage()" (click)="toolbarNextPage()" matTooltip="Next page">
            <mat-icon>chevron_right</mat-icon>
          </button>
          <button mat-icon-button *ngIf="userConfigService.inRoles(Role.StandardFeatureSet, Role.Administrator) && enableFeatureExpandToEmailFamily" (click)="toggleExpandEmailFamily()" [ngClass]="{'selected-browse-icon': expandEmailFamilySelected === true}" matTooltip="Expand to e-mail family"
                  [disabled]="hasActiveSearch && !searchQuickLinks.searchParameter.searchString">
            <mat-icon>attachment</mat-icon>
          </button>
          <button mat-icon-button *ngIf="userConfigService.inRoles(Role.Employee, Role.Administrator, Role.StandardFeatureSet)" (click)="openAiPanel()" [disabled]="disableAiPanel()" [matTooltip]="displayAiTooltip()">
            <mat-icon style="font-size: 20px; transform: translateY(-2px);">
              <div class="far fa-stars"></div>
            </mat-icon>
          </button>
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu" class="doc-viewer-wrapper-panel">
            <div class="fontify-13px;">
              <div style="padding-left: 16px; height: 48px;">
                <mat-icon style="vertical-align: bottom; margin-top: 12px;">wrap_text</mat-icon>
                <mat-checkbox style="margin-left: 8px; margin-bottom: 3px;" [(ngModel)]="wordWrap">Wrap</mat-checkbox>
              </div>
              <div style="padding-left: 16px;">
                <mat-icon style="vertical-align: middle;">unfold_less</mat-icon>
                <mat-slider #density [min]="rowDensityManger.min" [max]="rowDensityManger.max" [step]="rowDensityManger.step"
                            #ngSlider class="density-scale-down-slider">
                  <input matSliderThumb (change)="rowDensityManger.onChange()" #ngSliderThumb="matSliderThumb"
                         [(value)]="rowDensityManger.current" />
                </mat-slider>
                <mat-icon style="vertical-align: middle;">unfold_more</mat-icon>
              </div>
              <button mat-menu-item *inRole="[Role.StandardFeatureSet, Role.Administrator]" [matMenuTriggerFor]="layouts">
                <mat-icon>save</mat-icon>
                <span>Save Layout As</span>
              </button>
              <button mat-menu-item (click)="load()">
                <mat-icon>refresh</mat-icon>
                <span>Refresh page data</span>
              </button>
            </div>
          </mat-menu>
          <mat-menu #layouts="matMenu" class="density-neg-3">
            <div></div>
            <div class="grey-header" style="margin: 0 6px;">
              <div class="grey-header-left">Shared</div>
              <mat-icon class="grey-header-right">share</mat-icon>
            </div>
            <button mat-menu-item *ngFor="let shared of this.layoutQuickLinks.shared" class="fontify-13px lex-theme-font--classic" [disabled]="isDisableSaveLayout(shared.createdById)" (click)="saveLayoutAs(shared)">{{shared.title}}</button>
            <div class="grey-header-below" style="margin: 0 6px;">
              <div class="grey-header-left">Pinned</div>
              <mat-icon class="grey-header-right">push_pin</mat-icon>
            </div>
            <button mat-menu-item *ngFor="let pin of this.layoutQuickLinks.pinned" class="fontify-13px lex-theme-font--classic" [disabled]="isDisableSaveLayout(pin.createdById)" (click)="saveLayoutAs(pin)">{{pin.title}}</button>
            <div class="grey-header-below" style="margin: 0 6px;">
              <div class="grey-header-left">Recent</div>
              <mat-icon class="grey-header-right">history</mat-icon>
            </div>
            <button mat-menu-item *ngFor="let recent of this.layoutQuickLinks.recent" class="fontify-13px lex-theme-font--classic" [disabled]="isDisableSaveLayout(recent.createdById)" (click)="saveLayoutAs(recent)">{{recent.title}}</button>
          </mat-menu>
        </div>
      </mat-toolbar>

      <!-- Search -->
      <div style="display: flex; flex-grow: 1; padding-top: 16px; align-items: baseline;" *inRole="[Role.StandardFeatureSet, Role.Administrator]">
        <mat-form-field style="width:100%;" appearance="outline" class="show-no-errors open-search-bar hover-1 form-field-font--12px">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput #searchBox #trigger="matAutocompleteTrigger" (keyup.enter)="doSearch(true); trigger.closePanel()" [matAutocomplete]="auto" [formControl]="searchQuickLinks.searchControl">
          <mat-autocomplete #auto="matAutocomplete">
            @for (search of searchQuickLinks.filteredSearches | async; track search) {
            <mat-option [value]="search" style="--mat-option__font-size: 16px;">
              {{search}}
            </mat-option>
            }
          </mat-autocomplete>
          <button mat-button *ngIf="searchBox.value" matSuffix mat-icon-button aria-label="Clear Text" (click)="searchBox.value=''">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <button mat-button color="primary" style="height: 100%;" (click)="doSearch(true)">SEARCH</button>
        <button mat-button color="primary" style="height: 100%;" (click)="closeSearch();" [disabled]="!hasActiveSearch">RESET</button>
      </div>

      <mat-card appearance="outlined" class="card-under-toolbar mat-elevation-z2" style="overflow: hidden; display: flex; height: 100%;">
        <mat-card-content class="mat-elevation-z8" style="overflow: hidden; flex: auto; display: flex; flex-direction: column;">
          <div style="overflow: auto; height: 100%;">
            <div class="spinner-container" *ngIf="selectionService.dataSource.loading | async">
              <mat-spinner [diameter]="50"></mat-spinner>
            </div>
            <table mat-table [dataSource]="selectionService.dataSource" matSort class="table-width" [style.width.px]="columnResizer.tableWidth" [ngClass]="{'dim': (selectionService.dataSource.loading | async) }"
                   cdkDropList cdkDropListLockAxis="x" cdkDropListOrientation="horizontal" (cdkDropListDropped)="dropListDropped($event)">

              <ng-container matColumnDef="row-number">
                <th mat-header-cell *matHeaderCellDef class="row-number-header" style="padding-left: 0;">
                </th>
                <td mat-cell *matCellDef="let i = index; let element" class="row-number">
                  <span [ngClass]="{'expanded-text': element.isExpandedResult }">
                    {{i+1}}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="email-type">
                <th mat-header-cell *matHeaderCellDef style="width: 32px; text-align: center;">
                  Type
                </th>
                <td mat-cell *matCellDef="let element" style="text-align: center;">
                  <span *ngIf="element.emailType">
                    <span [ngSwitch]="element.emailType.value">
                      <span *ngSwitchCase="EmailType.Native.value">
                        <mat-icon style="font-size:6px" fontSet="material-icons-outlined" matTooltip="Native Document">insert_drive_file</mat-icon>
                      </span>
                      <span *ngSwitchCase="EmailType.EmailBody.value">
                        <mat-icon fontSet="material-icons-outlined" matTooltip="E-Mail Body">email</mat-icon>
                      </span>
                      <span *ngSwitchCase="EmailType.EmailAttachment.value">
                        <mat-icon fontSet="material-icons-outlined" matTooltip="Attachment">attach_email</mat-icon>
                      </span>
                      <span *ngSwitchDefault [matTooltip]="NA">
                        <mat-icon>article</mat-icon>
                      </span>
                    </span>
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef style="width: 62px; height: 50px; padding-left: 2px; padding-right: 2px;">
                  <mat-form-field>
                    <mat-select placeholder="Select" panelClass="mat-table-doc-selection-cdk">
                      <mat-option (click)="selectionService.selectAll()">All</mat-option>
                      <mat-option (click)="selectionService.selectCurrentPage()">Page</mat-option>
                      <mat-option (click)="selectionService.deselectAll()">None</mat-option>
                    </mat-select>
                  </mat-form-field>
                </th>
                <td mat-cell *matCellDef="let row" style="text-align: center">
                  <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selectionService.selection.toggle(row) : null"
                                [checked]="selectionService.selection.isSelected(row)">
                  </mat-checkbox>
                </td>
              </ng-container>

              <ng-container [matColumnDef]="field.fieldId" *ngFor="let field of displayedFieldLayout.fields; let i = index">
                <th mat-header-cell *matHeaderCellDef class="resizable" [style.width.px]="field.width" [matTooltip]="field.displayTitle"
                    cdkDrag [cdkDragDisabled]="columnResizer.field">
                  <div mat-sort-header class="table-header" [disabled]="shouldSortBeDisabled(field)">
                    <br>
                    <br>
                    <div *ngIf="field.displayType !== DisplayType.EyeIcon">{{field.displayTitle}}</div>
                    <div *ngIf="field.displayType === DisplayType.EyeIcon">
                      <mat-icon>remove_red_eye</mat-icon>
                    </div>
                  </div>
                  <div class="grip-handle" (mousedown)="columnResizer.onResizeColumnStart($event, field)"></div>
                </th>
                <td mat-cell *matCellDef="let element" [ngClass]="{'custom-parent': field.displayType === DisplayType.CustomParent}">
                  <span *ngIf="field.displayType === DisplayType.Normal">{{getProp(element, field.path)}}</span>
                  <span *ngIf="field.displayType === DisplayType.Link" [style.paddingLeft.px]="element.childLevel * 10">
                    <a id="browse-table-link-{{element.docId}}" href="/review/doc-viewer?DocId={{element.docId}}{{hasActiveSearch ? '&s=1' : ''}}{{hasAutoRedactionFilter ? '&ar=1':''}}" target="DocViewer">
                      {{getProp(element, field.path)}}
                    </a>
                    <div *ngIf="field.fieldId === builtInFieldIds.DocTitle && hasActiveSearch" class="synopsis" [innerHTML]="element.searchMetadata.synopsis"></div>
                  </span>
                  <span *ngIf="field.displayType === DisplayType.Custom" [matTooltip]="getCustomFieldValue(element, field)">{{getCustomFieldValue(element, field)}}</span>
                  <span *ngIf="field.displayType === DisplayType.EyeIcon" [matTooltip]="element.coding.reviewedBy" style="margin-left: 5px;">
                    <mat-icon *ngIf="getProp(element, field.path)">remove_red_eye</mat-icon>
                  </span>
                  <span *ngIf="field.displayType === DisplayType.CustomChecked" [matTooltip]="field.displayTitle">
                    <mat-icon *ngIf="getCustomFieldValue(element, field)">check</mat-icon>
                  </span>
                  <span *ngIf="field.displayType === DisplayType.Numeric" style="text-align: right; flex-direction: row; box-sizing: border-box; display: flex;">
                    <span style="width: 50%;">{{getProp(element, field.path)}}</span>
                    <span style="width: 50%;"> </span>
                  </span>
                  <span *ngIf="field.displayType === DisplayType.BuiltInCheck">
                    <span [ngSwitch]="field.fieldId">
                      <span *ngSwitchCase="builtInFieldIds.IsKey">
                        <mat-icon *ngIf="getProp(element, field.path)" matTooltip="Key Document">vpn_key</mat-icon>
                      </span>
                      <span *ngSwitchCase="builtInFieldIds.HasNotes">
                        <mat-icon *ngIf="getProp(element, field.path)" matTooltip="Has Note">assignment</mat-icon>
                      </span>
                      <span *ngSwitchCase="builtInFieldIds.Issues" [matTooltip]="getIssueString(element)">
                        <mat-icon *ngIf="getProp(element, field.path)">check</mat-icon>
                      </span>
                      <span *ngSwitchDefault>
                        <mat-icon *ngIf="getProp(element, field.path)">check</mat-icon>
                      </span>
                    </span>
                  </span>
                  <span *ngIf="field.displayType === DisplayType.Date">{{getProp(element, field.path) | date:'M/d/yyyy h:mm:ss a'}}</span>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: columnsToDisplay;" [style.height.px]="ngSliderThumb.value"
                  [ngClass]="{
                  'selected': selectionService.selection.isSelected(row),
                  'word-wrap': wordWrap,
                  'no-wrap': !wordWrap,
                  'expanded-row': row.isExpandedResult }">
              </tr>
            </table>
          </div>
          <div class="paging-container">
            <div class="page-select">
              <mat-label class="mat-paginator mat-paginator-page-size-label">Go to page:</mat-label>
              <mat-form-field class="page-text">
                <input matInput #pageInput min="1" max="{{selectionService.dataSource.totalPages}}"
                       (keyup.enter)="setPage(pageInput.value)"
                       [(ngModel)]="selectionService.dataSource.currentPageNumber" tabindex="-1">
              </mat-form-field>
              <div> / {{selectionService.dataSource.totalPages}}</div>
            </div>
            <mat-paginator class="density-neg-5"
                           [pageSize]="selectionService.pageSize"
                           [pageSizeOptions]="[10, 25, 50, 100, 200]"
                           [length]="selectionService.dataSource.count"
                           showFirstLastButtons>
            </mat-paginator>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>